import { createSelector } from 'reselect';
import { getProfiles } from './profiles';

const getHasToken = state => state.auth.hasToken;
const getIsIncorrectMessageVisible = state =>
  state.auth.isIncorrectPasswordMessageVisible;

export const getIsConnectionFailedMessageVisible = state =>
  state.auth.isConnectionFailedMessageVisible;

export const getIsUnauthorizedMessageVisible = state =>
  state.auth.isUnauthorizedMessageVisible;

const getIsLoading = state => state.auth.isFetching;
const getPage = state => (!state.auth.hasToken ? 'login' : 'profile');

export const getLogin = createSelector(
  getHasToken,
  getIsLoading,
  getIsIncorrectMessageVisible,
  getIsConnectionFailedMessageVisible, // Position 4
  getIsUnauthorizedMessageVisible,     // Position 5
  getPage,
  getProfiles,
  (
    hasToken,
    isLoading,
    isIncorrectPasswordMessageVisible,
    isConnectionFailedMessageVisible, // Matches Pos 4
    isUnauthorizedMessageVisible,     // Matches Pos 5
    page,
    profiles
  ) => ({
    hasToken,
    isLoading,
    isIncorrectPasswordMessageVisible,
    isConnectionFailedMessageVisible,
    isUnauthorizedMessageVisible,
    page,
    profiles
  })
);
